<template>
  <div class="selectPeople" ref="modal">
    <a-modal
      :title="title"
      :visible="visible"
      ok-text="确认"
      cancel-text="取消"
      @ok="confirm"
      @cancel="cancel"
      destroyOnClose
      :getContainer="() => this.$refs.modal"
    >
      <div style="overflow: hidden">
        <div style="float:left">
          <a-transfer
            :list-style="{
              width: '300px',
              height: '400px'
            }"
            show-search
            :data-source="getDataSource"
            :target-keys="getTargetKeys"
            :titles="['可选人员', '已选人员']"
            :selected-keys="getSelectKeys"
            :render="(item) => item.title"
            :disabled="disabled"
            @change="handleChange"
            @search="() => {}"
            @selectChange="handleSelectChange"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onOk: {
      type: Function,
      default: () => {}
    },
    onCancel: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: '选择人员'
    },
    dataSource: {
      // 穿梭框数据
      type: Array,
      default: () => {
        return []
      }
    },
    selectedKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
    multiple: {
      // 单选、多选，默认多选
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      targetKeys: this.selectedKeys || [], //	显示在右侧框数据的 key 集合
      selectKeys: [], // 设置左边哪些项应该被选中
      disabled: false // 穿梭框是否禁用
    }
  },
  watch: {
    // 监听默认选中值的变化
    selectedKeys(value) {
      this.targetKeys = value
    }
  },
  computed: {
    params() {
      return {
        onOk: this.onOk || (() => {}),
        onCancel: this.onCancel || (() => {})
      }
    },
    getDataSource() {
      return this.dataSource.map((item) => {
        return {
          ...item,
          key: item.key.toString()
        }
      })
    },
    getTargetKeys() {
      return this.targetKeys.map((item) => {
        return item.toString()
      })
    },
    getSelectKeys() {
      return this.selectKeys.map((item) => {
        return item.toString()
      })
    }
  },
  mounted() {
    // console.log(this)
  },
  methods: {
    // 弹出框点确认
    confirm() {
      // const select = []
      // for (let j = 0; j < this.targetKeys.length; j++) {
      //   for (let i = 0; i < this.mockData.length; i++) {
      //       if (this.mockData[i].key === this.targetKeys[j]) {
      //         select.push(this.mockData[i])
      //         break
      //       }
      //     }
      // }
      const newData = this.targetKeys.map((item) => {
        return parseInt(item)
      })
      this.params.onOk(newData)
    },
    // 弹出框关闭
    cancel() {
      this.targetKeys = this.selectedKeys // 取消时将选中项清为一开始的默认值
      this.params.onCancel()
    },
    // 设置穿梭框是否不可点击
    handleDisable(disabled) {
      this.disabled = disabled
    },
    // 穿梭框左右数据切换
    handleChange(nextTargetKeys, direction, moveKeys) {
      if (this.multiple) {
        this.targetKeys = nextTargetKeys
      } else {
        this.targetKeys = [nextTargetKeys[0]]
      }
    },
    // 选中项发生改变时的回调函数
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectKeys = [...sourceSelectedKeys, ...targetSelectedKeys]
    }
  }
}
</script>

<style scoped lang="less">
.selectPeople {
  /deep/ .ant-modal {
    width: 688px;
    min-width: 688px;
  }
}
</style>
